import { AmountTypeValues, type PaymentAmount } from '../types'

export function isFullOnlyPayment(paymentAmounts: PaymentAmount[]): boolean {
  return paymentAmounts.length === 1 && paymentAmounts[0].type === AmountTypeValues.FULL
}
